import {Exclude, Type} from 'class-transformer';
import {GLOBAL, IdCodeNameModel} from 'common-shared';
import {PropertyMappingModel} from "../../properties/models/property-mapping.model";
import {SpecLineModel} from "../../properties/models/spec-line.model";
import {ItemInItemGroupModel} from "./manufacturing-item.model";
import {MasterOperationModel} from "./master-operation.model";
import {ProcessSelectorModel} from "./process-selector.model";
import {UnitConversionModel} from "../../common/unit-conversions/models/unit-conversion.model";
import {BaseConnectionModel} from "./base-connection.model";

export class ManufacturingItemGroupModel extends IdCodeNameModel {
  constructor(init?: Partial<ManufacturingItemGroupModel>) {
    super();
    Object.assign(this, init);
  }

  AutoReplenishFlagClv?: string;
  SaveRouting = false;
  @Type(() => MasterOperationModel)
  MasterOperations: MasterOperationModel[];

  @Type(() => ProcessSelectorModel)
  ProcessSelectors: ProcessSelectorModel[] = [];

  TypeClv: string;
  @Exclude({toPlainOnly: true})
  @Type(() => PropertyMappingModel)
  $InheritedProcedureItemProperties: PropertyMappingModel[];
  @Type(() => PropertyMappingModel)
  ProcedureItemProperties: PropertyMappingModel[];
  Comment: string;
  @Type(() => ItemGroupInItemGroupModel)
  Children: ItemGroupInItemGroupModel[] = [];
  @Type(() => ItemGroupInItemGroupModel)
  Parents: ItemGroupInItemGroupModel[] = [];
  @Type(() => ItemInItemGroupModel)
  ItemInItemGroups: ItemInItemGroupModel[] = [];
  @Type(() => UnitConversionModel)
  UnitConversions: UnitConversionModel[] = [];
  HierarchyNodes: string[] = [];
  RowVersion: string;
  ModifiedBy: string;
  @Type(() => Date)
  ModifiedDate: Date;
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];
  InventoryUnitId: string;
  ProductionUnitId: string;
  RouteUnitId: string;
  ForceSave: boolean;
  StatusClv: string;
  ParentId: string;
  DraftId: string;

  isManufactured() {
    return this.TypeClv && this.TypeClv !== GLOBAL.Classificators.ItemGroupType.RawMaterial;
  }

  isImeLoaded(): boolean {
    return this.MasterOperations?.length > 0;
  }

  isValid(): boolean {
    return this.Specs.every(spec => spec.isValid());
  }
}

export class ItemGroupInItemGroupModel extends BaseConnectionModel {
  constructor(init?: Partial<ItemGroupInItemGroupModel>) {
    super();
    Object.assign(this, init);
  }

  ChildId: string;
  ParentId: string;
}
